import {Component,Inject, Input} from 'ng-metadata/core';
import {ControlledVocabularyService} from './controlledVocabulary.service';
import {ConfigurationUtil} from "../../nddUtils/configurationUtil.service";
import {STATE_NAMES} from '../../primoExplore/primoExploreStates.module';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";
import {SearchService} from './../search.service';

const get = require('lodash/get');

@Component({
    providers:[],
    selector: 'prm-controlled-vocabulary',
    templateUrl: 'components/search/controlledVocabulary/controlled-vocabulary.html',
})

export class ControlledVocabulary {
    @Input() private equivalentTerm: string;
    @Input() private query: string;

    constructor(private controlledVocabularyService: ControlledVocabularyService,
                @Inject('$state') private $state:angular.ui.IStateService,
                private searchService: SearchService,
                private primolyticsService: PrimolyticsService,
                private configurationUtil: ConfigurationUtil){

    }

    ngOnInit() {
        if(!get(this,'searchService.cameFromParams.pagination')){
            this.primolyticsService.doBeaconReport({'p':'brief', 'op':'controlledVocabularyDisplayed'}, null, this.primolyticsService.getTimestamp());
        }
    }

    get stateParams(){
        return this.controlledVocabularyService.getStateParams();
    }
    get STATE(){
        if(this.configurationUtil.isSuprima() && this.$state.current.name === STATE_NAMES.JOURNAL_SEARCH ){
            return STATE_NAMES.JOURNAL_SEARCH;
        }
        return STATE_NAMES.SEARCH;
    }
    getEquivalentTerm() {
        return {
            equivalentTerm: `"<span class="bold-text text-italic">${this.equivalentTerm}</span>"`
        };
    }
    getOriginalQuery() {
    	var q = this.query.split(',AND')[0];
        return {
            query: `<span class="bold-text text-italic">${q}</span>`
        }
    }

    public goToSearchOnly(stateParams){
        this.primolyticsService.doBeaconReport({'p':'brief', 'op':'justSearch'}, null, this.primolyticsService.getTimestamp());
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/controlledVocabulary/controlledVocabulary.directive.ts